// using ES6 modules
import { createBrowserHistory } from 'history';
export const history = createBrowserHistory()